<template>
	<!-- 派单录入 -->
	<div class="billOperationRecord public_Spacing">
		<div class="pulbic_oparetionBlock" style="margin-bottom: 12px;">
			<div class="public_criteriaRange">
				<div class="public_oparetionBlock_Menu" >
					<label class="public_lbSty">企业：</label>
					<el-select class="public_optionSty dropDown_Define" @change="erpChange" v-model="enterpriseTwo" placeholder="请选择" >
						<el-option v-for="item in enterpriseTwoOptionList" :key="item.SETTB99ID" :label="item.SETTB99CA00" :value="item.SETTB99ID">
						</el-option>
					</el-select>
				</div>
				<div class="public_oparetionBlock_Menu">
					<label class="public_lbSty">客户：</label>
					<el-select class="public_optionSty dropDown_Define"  v-model="customerMo" placeholder="请选择"
					 filterable>
						<el-option v-for="item in customerOptions" :key="item.ORMTB410ID" :label="item.ORMTB410CA00" :value="item.ORMTB410ID">
						</el-option>
					</el-select>
				</div>
				<div class="public_oparetionBlock_Menu">
					<label class="public_lbSty">物料：</label>
					<el-select class="public_optionSty dropDown_Define" v-model="materielMo" placeholder="请选择"
					 filterable>
						<el-option v-for="item in materielOptions" :key="item.SETTB109ID" :label="item.SETTB109CA00" :value="item.SETTB109ID">
						</el-option>
					</el-select>
				</div>
				<div class="public_oparetionBlock_Menu">
					<label class="public_lbSty">状态：</label>
					<el-select class="public_optionSty dropDown_Define" v-model="SETTB122CA07" placeholder="请选择">
						<el-option v-for="item in dataStatusOperation" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</div>
				<div class="public_oparetionBlock_Menu">
					<label class="public_lbSty">车牌号：</label>
					<div class="el-select public_optionSty">
						<div class="el-input el-input--suffix">
							<input class="pulic_carNumber" type="text" placeholder="请输入" v-model="carNumber" />
						</div>
					</div>
				</div>
				<div class="public_oparetionBlock_Menu">
					<label class="public_lbSty">派单号：</label>
					<div class="el-select public_optionSty">
						<div class="el-input el-input--suffix">
							<input class="pulic_carNumber" type="text" placeholder="请输入" v-model="ORMTB440CA00" />
						</div>
					</div>
				</div>
			</div>
			<div class="public_operatArea">
				<span class="pulic_operatArea_now pulic_cursor" :class="dateNowDayActive?'public_dateActive':''" @click="getNowDay">当日</span>
				<span class="public_operatArea_yesterday pulic_cursor" :class="dateYesterdayActive?'public_dateActive':''" @click="getYesterday">昨天</span>
				<span class="pulic_operatArea_now pulic_cursor" :class="dateNowMonthActive?'public_dateActive':''" @click="sameMonth">当月</span>
				<span class="public_operatArea_yesterday pulic_cursor" :class="dateLastMonthActive?'public_dateActive':''" @click="lastMonth">上月</span>
				<div class="public_operatArea_timePicker pulic_cursor">
					<el-date-picker v-model="date" value-format="yyyy-MM-dd" type="daterange" range-separator="至" :picker-options="startDateDisabled" @change="datePickerChange"
					 start-placeholder="开始日" end-placeholder="结束日" class="pulic_cursor">
					</el-date-picker>
				</div>
				<div class="public_operatBtn">
					<button @click="queryClick" class="public_saleWater_chaxun pulic_cursor"    id="查询"><i class="iconfont icon-chaxun"></i>查询</button>
					<!-- <button class="public_saleWater_daochu pulic_cursor" @click="exports"    id="导出"><i class="iconfont icon-daochu"></i>导出</button> -->
					<el-popover ref="popover2" trigger="click">
						<div style="text-align: left;padding-left: 20px;padding-top: 8px;">
							<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
							<div style="margin: 15px 0;"></div>
							<el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
								<el-checkbox style="display: block;" class="salesWater_checkbox" v-for="city in cities" :label="city" :key="city">{{city}}</el-checkbox>
							</el-checkbox-group>
						</div>
					</el-popover>
				</div>
			</div>
		</div>
		<div class="billOperationRecord-table pulbic_table_container">
			<el-table tooltip-effect="dark" :data="tableData" style="width: 100%;" max-height="90%"  :default-sort="{prop: 'waterNum', order: 'descending'}"
			 :header-cell-style="{color:'rgba(51,51,51,1)','font-weight':'bold'}" class="public_tableColumn" >
				<el-table-column v-for='(item,index) in tableHeadList' :width="item.width" :prop="item.prop" :label="item.label" :key="index">
				</el-table-column>
				<el-table-column label="操作" width="200">
					<template slot-scope="scope">
						<el-button class="public_icon_xiangqing public_icon_width  public_icon_margin" type="primary" size="small" @click="DetailsClick(scope.row)">详情</el-button>
						<el-button class="public_icon_xiangqing public_icon_width  public_icon_margin" v-if="scope.row.ORMTB440CC10==1"  type="primary" size="small" @click="isorderAuditClick(scope.row)">录入</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="pulbic_pagesize">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage"
				 :page-sizes="[10, 20, 30, 40]" :page-size="limitMo" layout="total,sizes, prev, pager, next" :total="pagingPageMo">
				</el-pagination>
			</div>
		</div>
		<div class="public-dialog">
			<el-dialog title="详情" :visible.sync="oerderDetilsShow" width="30%" @close="detailsList=''"  :closeOnClickModal='false'>
				<div class="DetailsWater-Dialog">
					<div class="DWD-li">
						<div class="DWD-li-title">流水号</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CC07||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">企业名称</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CA05||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">客户名称</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CA03||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">车牌号</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CA01||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">派单时间</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CA19||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">结算时间</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CC00||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">回执时间</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CE00||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">原因</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CD01||''}}</div>
					</div>
					<div class="DWD-table">
						<div class="DWD-table-left-title">
							<div></div>
							<div>派单</div>
							<div>结算</div>
							<div>回执</div>
						</div>
						<div class="DWD-table-left-flex">
							<div>物料</div>
							<div>{{detailsList.ORMTB440CA07||''}}</div>
							<div>{{detailsList.ORMTB440CC02||''}}</div>
							<div></div>
						</div>
						<div class="DWD-table-left-flex">
							<div>重量</div>
							<div>{{detailsList.ORMTB440CA10||''}}</div>
							<div>{{detailsList.ORMTB440CC04||''}}</div>
							<div>{{detailsList.ORMTB440CE02||''}}</div>
						</div>
						<div class="DWD-table-left-flex">
							<div>金额</div>
							<div>{{detailsList.ORMTB440CA11||''}}</div>
							<div>{{detailsList.ORMTB440CC06||''}}</div>
							<div></div>
						</div>
					</div>
				</div>
				<div class="DetailsWater-img">
					<div class="DetailsWater-img-text">回执记录</div>
					<el-image 
					    style="width: 80px; height: 80px"
					    :src="DetailsWaterurl" 
					    :preview-src-list="DetailsWatersrcList">
					</el-image>
				</div>
			</el-dialog>
		</div>
		<div class="public-dialog">
			<el-dialog title="录入" :visible.sync="isorderAuditShow" @close="detailsList='',isorderAuditText=''" width="30%"  :closeOnClickModal='false'>
				<div class="DetailsWater-Dialog ">
					<div class="DWD-li">
						<div class="DWD-li-title">流水号</div>
						<div class="DWD-li-text"><input type="" v-model="detailsList.ORMTB440CC07" maxlength="20"/></div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">企业名称</div>
						<div class="DWD-li-text"><input type="" v-model="detailsList.ORMTB440CA05" readonly/></div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">客户名称</div>
						<div class="DWD-li-text"><input type="" v-model="detailsList.ORMTB440CA03" readonly/></div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">车牌号</div>
						<div class="DWD-li-text"><input type="" v-model="detailsList.ORMTB440CA01" readonly/></div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">派单时间</div>
						<div class="DWD-li-text"><input type="" v-model="detailsList.ORMTB440CA19" readonly/></div>
					</div>
					<div class="DWD-li ">
						<div class="DWD-li-title">结算时间</div>
						<div class="DWD-li-text public-DetailsWater-Dialog-li">
							<el-date-picker v-model="detailsList.ORMTB440CC00" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期">
							</el-date-picker>
						</div>
					</div>
					<div class="DWD-li ">
						<div class="DWD-li-title">回执时间</div>
						<div class="DWD-li-text public-DetailsWater-Dialog-li">
							<el-date-picker v-model="detailsList.ORMTB440CE00" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期">
							</el-date-picker>
						</div>
					</div>
					<div class="DWD-table">
						<div class="DWD-table-left-title">
							<div></div>
							<div>派单</div>
							<div>结算</div>
							<div>回执</div>
						</div>
						<div class="DWD-table-left-flex ">
							<div>物料</div>
							<div><input type="" v-model="detailsList.ORMTB440CA07" readonly/></div>
							<div class="public-DetailsWater-Dialog-li">
								<el-select v-model="detailsList.ORMTB440CC01" placeholder="请选择">
									<el-option v-for="(item,index) in updateMaterialList" :key="item.SETTB109ID" :label="item.SETTB109CA00" :value="item.SETTB109ID">
									</el-option>
								</el-select>
							</div>
							<div></div>
						</div>
						<div class="DWD-table-left-flex">
							<div>重量</div>
							<div><input type="" v-model="detailsList.ORMTB440CA10" readonly/></div>
							<div><input type="" v-model="detailsList.ORMTB440CC04"  @input="JSWeight"/></div>
							<div><input type="" v-model="detailsList.ORMTB440CE02" @input="HZWeight"/></div>
						</div>
						<div class="DWD-table-left-flex">
							<div>金额</div>
							<div><input type="" v-model="detailsList.ORMTB440CA11" readonly/></div>
							<div><input type="" v-model="detailsList.ORMTB440CC06" readonly @input="JSmoney"/></div>
							<div><input type="" v-model="detailsList.ORMTB440CE04" readonly @input="HZmoney"/></div>
						</div>
					</div>
				</div>
				<div class="DetailsWater-img">
					<div class="DetailsWater-img-text" style="display: inline-block;">回执记录</div>
					<div id="" style="display: inline-block;">
						<el-upload ref="upload" multiple action="" list-type="picture-card" :on-preview="handlePreview" :on-remove="handleRemove"
						 :on-change="handlechange" :limit='1' accept="image/gif,image/jpeg,image/jpg,image/png,image/svg" :file-list="fileList"
						 :auto-upload="false">
							<i class="el-icon-plus"></i>
						</el-upload>
					</div>
				</div>
				<div style="margin-top: 20px;text-align: center;">
					<el-button type="danger" @click="isorderAuditShow=false"> 取消</el-button>
					<el-button type="primary" @click="isorderAuditServe">确定</el-button>
				</div>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				fileList:[],
				imgFormdate:[],
				isorderAuditText:'',
				oerderDetilsShow: false,
				orderAuditShow: false,
				isorderAuditShow:false,
				returnReceiptShow:false,
				uobj: this.$store.state.uobj, //登陆缓存--用户信息
				date: [], //日期
				dateNowDayActive:false,
				dateYesterdayActive:false,
				dateNowMonthActive:false,
				dateLastMonthActive:false,
				twolevelUserLogin: true,
				timeIndex: 0, //判断第几次切换当月时间
				sameMonthTime: '', //目前月份
				currentMonthTime: '', //目前月份--上月+1
				tableData: [],
				ORMTB440CA00:'',
				materialOptions: [],
				materialTypeValue: '',
				customerOptions: [{
					ORMTB410ID: '',
					ORMTB410CA00: '全部',
				}],
				carNum: '',
				materielMo:'',
				materielOptions:[{
					SETTB109CA00: '全部',
					SETTB109ID: '',
				}],
				// 状态
				dataStatusOperation: [{
					value: '',
					label: '全部',
				}, {
					value: '0',
					label: '自动结算',
				}, {
					value: '1',
					label: '手动录入',
				}, {
					value: '2',
					label: '录入完毕',
				}],
				// 查询
				customerMo: '', //客户--查询		
				SETTB122CA07: '', //数据状态
				billOperationAdd: false,
				enterpriseTwoOptionList: [{
					SETTB109CA00: '全部',
					SETTB109ID: '',
				}], //二级企业下拉框--新增
				enterpriseTwo: '', //二级企业
				carNumber: '', //车牌号
				pageMo: 1, //默认列表页码
				limitMo: 10, //每页的条数
				pagingPageMo: 0, //分页--数据列表共有的条数
				currentPage: 1, //设置当前页默认为1
				// 列设置
				checkAll: true,
				checkedCities: ['派单时间', '派单编号', '企业名称', '客户名称', '车牌号', '订单物料', '完成物料', '重量', '完成状态','录入状态'],
				cities: ['派单时间', '派单编号', '企业名称', '客户名称', '车牌号', '订单物料', '完成物料', '重量', '完成状态','录入状态'],
				isIndeterminate: false,
				// 详情
				billOperationDetails: false,
				detailsList: '', //详情列表
				tableHeadList: [{
						prop: 'ORMTB440CA19',
						label: '派单时间',
					},
					{
						prop: 'ORMTB440CA00',
						label: '派单编号',
					},
					{
						prop: 'ORMTB440CA05',
						label: '企业名称',
					},
					{
						prop: 'ORMTB440CA03',
						label: '客户名称',
					},

					{
						prop: 'ORMTB440CA01',
						label: '车牌号',
					},
					{
						prop: 'ORMTB440CA07',
						label: '订单物料',
					},
					{
						prop: 'ORMTB440CC02',
						label: '完成物料',
					},
					{
						prop: 'ORMTB440CA10',
						label: '重量',
					},
					{
						prop: 'ORMTB440CF01text',
						label: '完成状态',
					},
					{
						prop: 'auditText',
						label: '录入状态',
					},
				],
				tableHeadListInit: [{
						prop: 'ORMTB440CA19',
						label: '派单时间',
					},
					{
						prop: 'ORMTB440CA00',
						label: '派单编号',
					},
					{
						prop: 'ORMTB440CA05',
						label: '企业名称',
					},
					{
						prop: 'ORMTB440CA03',
						label: '客户名称',
					},

					{
						prop: 'ORMTB440CA01',
						label: '车牌号',
					},
					{
						prop: 'ORMTB440CA07',
						label: '订单物料',
					},
					{
						prop: 'ORMTB440CC02',
						label: '完成物料',
					},
					{
						prop: 'ORMTB440CA10',
						label: '重量',
					},
					{
						prop: 'ORMTB440CF01text',
						label: '完成状态',
					},
					{
						prop: 'auditText',
						label: '录入状态',
					},
				],
				isRefresh: true,
				isRefreshSetInterval: '',
				// quanpDisabled: false,
				// 历史缓存
				currentUrl: this.$route.path,
				historyInfo: '',
				// 时间限制
				// 限制开始日期不能超过当前日期
				startDateDisabled: {
					disabledDate(time) {
						return time.getTime() > Date.now();
					}
				},
				solelist: [],
				DetailsWaterurl: '',
				DetailsWatersrcList: [],
				updateMaterialList:[],
			}
		},
		created() {
			var list = "";
			list = this.$store.state.solelist;
			// 赋值，缓存销毁
			this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl))
			sessionStorage.removeItem(this.currentUrl)
			if (this.historyInfo != null && this.historyInfo != '') {
				this.init()
			} else {
				this.getNowDay();
			}
			var path = this.$route.path;
			if (path === '/SalesDispatchManagement') {
				path = '/Home' + path
			}
			this.solelist = this.$baseAPI.querSoleList(list, path); //获取权限列表
		},
		mounted() {
			this.optionLists()
			this.enterprise0ptions()
			
		},
		// 存储数据
		beforeDestroy() {
			var obj = {
				startTime: [this.date[0], this.date[1]], //开始时间
				ORMTB440CA02: this.ORMTB440CA02, //客户id
				ORMTB400CA03: this.ORMTB400CA03, //客户名称
				ORMTB440CA04: this.ORMTB440CA04, //客户名称
				ORMTB440CA06: this.ORMTB440CA06, //二级企业id
				ORMTB440CF01: this.ORMTB440CF01, //二级企业名称
				ORMTB440CA00: this.ORMTB440CA00, //数据状态--转换
				ORMTB440CA01: this.ORMTB440CA01, //数据状态--名字
				currentPage: this.currentPage, //当前页数
				pageMo: this.pageMo, //页码
				limitMo: this.limitMo, //每页条数
				dateNowDayActive: this.dateNowDayActive,
				dateYesterdayActive: this.dateYesterdayActive,
				dateNowMonthActive: this.dateNowMonthActive,
				dateLastMonthActive: this.dateLastMonthActive,
				ORMTB440CA00:this.ORMTB440CA00
			}
			sessionStorage.setItem(this.currentUrl, JSON.stringify(obj))
		},
		methods: {
			//初始化数据
			init() {
				this.date = this.historyInfo.startTime
				this.ORMTB440CA02 = this.historyInfo.ORMTB440CA02
				this.ORMTB400CA03 = this.historyInfo.ORMTB400CA03
				this.ORMTB440CA04 = this.historyInfo.ORMTB440CA04
				this.ORMTB440CA06 = this.historyInfo.ORMTB440CA06
				this.ORMTB440CF01 = this.historyInfo.ORMTB440CF01
				this.ORMTB440CA00 = this.historyInfo.ORMTB440CA00
				this.ORMTB440CA01 = this.historyInfo.ORMTB440CA01
				this.currentPage = this.historyInfo.currentPage
				this.pageMo = this.historyInfo.pageMo
				this.limitMo = this.historyInfo.limitMo
				this.dateNowDayActive = this.historyInfo.dateNowDayActive
				this.dateYesterdayActive = this.historyInfo.dateYesterdayActive
				this.dateNowMonthActive = this.historyInfo.dateNowMonthActive
				this.dateLastMonthActive = this.historyInfo.dateLastMonthActive
				this.ORMTB440CA00 = this.historyInfo.ORMTB440CA00
			},
			handleRemove(file, fileList) {
				this.imgFormdate = fileList
			},
			handlechange(file, fileList) {
				this.imgFormdate = fileList
			},
			handlePreview(file) {
			},
			JSWeight(){
				var value = this.detailsList.ORMTB440CC04.toString();
				var num = this.$baseAPI.twoDecimal(value);
				if (num > 9999999)
					this.$message.error('金额高于最大限制9999999')
				num = num > 9999999 ? 9999999 : num
				this.detailsList.ORMTB440CC04 = num
			},
			HZWeight(){
				var value = this.detailsList.ORMTB440CE02.toString();
				var num = this.$baseAPI.twoDecimal(value);
				if (num > 9999999)
					this.$message.error('金额高于最大限制9999999')
				num = num > 9999999 ? 9999999 : num
				this.detailsList.ORMTB440CE02 = num
			},
			JSmoney(){
				var value = this.detailsList.ORMTB440CC06.toString();
				var num = this.$baseAPI.twoDecimal(value);
				if (num > 9999999)
					this.$message.error('金额高于最大限制9999999')
				num = num > 9999999 ? 9999999 : num
				this.detailsList.ORMTB440CC06 = num
			},
			HZmoney(){
				var value = this.detailsList.ORMTB440CE04.toString();
				var num = this.$baseAPI.twoDecimal(value);
				if (num > 9999999)
					this.$message.error('金额高于最大限制9999999')
				num = num > 9999999 ? 9999999 : num
				this.detailsList.ORMTB440CE04 = num
			},
			// 导出
			exports() {
				var startTime= this.date[0]; //开始时间
				var endTime= this.date[1]; //结束时间
				var ORMTB440CA02= this.customerMo; //二级客户ID
				var ORMTB400CA03= this.uobj.ormtb400.ORMTB400CA03; //一级客户代码
				var ORMTB440CA04= this.enterpriseTwo;//二级企业ID
				var ORMTB440CA06= this.materielMo; //物料ID
				var ORMTB440CF01= this.SETTB122CA07; //状态
				var ORMTB440CA00=this.ORMTB440CA00;//订单号
				var ORMTB440CA01=this.carNumber;//车牌号
				var url = this.axios.defaults.baseURL + "/orm/ormtb440/exc/toExcel?startTime=" + startTime + "&endTime=" +
					endTime + "&ORMTB440CA02=" + ORMTB440CA02 + "&ORMTB400CA03=" + ORMTB400CA03 +
					"&ORMTB440CA04=" + ORMTB440CA04 + "&ORMTB440CA06=" + ORMTB440CA06 + "&ORMTB440CF01=" +
					ORMTB440CF01 + "&ORMTB440CA00=" + ORMTB440CA00+ "&ORMTB440CA01=" + ORMTB440CA01;
				window.location.href = url;
			},
			topWeightInput(){
				this.detailsList.ORMTB440CE02 = this.detailsList.ORMTB440CE02.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
				this.detailsList.ORMTB440CE02= this.detailsList.ORMTB440CE02.replace(/^\./g, ""); //验证第一个字符是数字
				this.detailsList.ORMTB440CE02 = this.detailsList.ORMTB440CE02.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
				this.detailsList.ORMTB440CE02 = this.detailsList.ORMTB440CE02.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
				this.detailsList.ORMTB440CE02 = this.detailsList.ORMTB440CE02.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
				if (this.detailsList.ORMTB440CE02.indexOf(".") < 0 && this.detailsList.ORMTB440CE02 != "") { //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
					this.detailsList.ORMTB440CE02 = parseFloat(this.detailsList.ORMTB440CE02);
				}
				this.$refs.topWeight.value = this.detailsList.ORMTB440CE02
			},
			topWeightChange(){
				var index = String(this.detailsList.ORMTB440CE02).indexOf('.')
				if (index == -1) return
				var numArr = this.detailsList.ORMTB440CE02.split('.')
				if (numArr[1].length == 0) {
					this.$refs.topWeight.value = numArr[0]
					this.detailsList.ORMTB440CE02 = numArr[0]
				} else {
					this.$refs.topWeight.value = numArr[0] + '.' + numArr[1]
					this.detailsList.ORMTB440CE02 = numArr[0] + '.' + numArr[1]
				}
			},
			topMoneyInput() { //充值金额实时校验
				this.detailsList.ORMTB440CA21 = this.detailsList.ORMTB440CA21.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
				this.detailsList.ORMTB440CA21= this.detailsList.ORMTB440CA21.replace(/^\./g, ""); //验证第一个字符是数字
				this.detailsList.ORMTB440CA21 = this.detailsList.ORMTB440CA21.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
				this.detailsList.ORMTB440CA21 = this.detailsList.ORMTB440CA21.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
				this.detailsList.ORMTB440CA21 = this.detailsList.ORMTB440CA21.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
				if (this.detailsList.ORMTB440CA21.indexOf(".") < 0 && this.detailsList.ORMTB440CA21 != "") { //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
					this.detailsList.ORMTB440CA21 = parseFloat(this.detailsList.ORMTB440CA21);
				}
				this.$refs.topMoney.value = this.detailsList.ORMTB440CA21
			},
			topMoneyChange() { //充值金额失去焦点数据处理
				var index = String(this.detailsList.ORMTB440CA21).indexOf('.')
				if (index == -1) return
				var numArr = this.detailsList.ORMTB440CA21.split('.')
				if (numArr[1].length == 0) {
					this.$refs.topMoney.value = numArr[0]
					this.detailsList.ORMTB440CA21 = numArr[0]
				} else {
					this.$refs.topMoney.value = numArr[0] + '.' + numArr[1]
					this.detailsList.ORMTB440CA21 = numArr[0] + '.' + numArr[1]
				}
			},
			returnReceiptserve(){
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					ORMTB440CE07: this.uobj.pertb005.pertb005id, //开始时间
					ORMTB440CE08:this.uobj.pertb005.pertb005ca02,
					ORMTB440CE09:this.detailsList.ORMTB440CE02,
					ORMTB440ID:this.detailsList.ORMTB440ID,
					ORMTB440CA21:this.detailsList.ORMTB440CA21,
				}
				console.log(this.detailsList)
				this.tableData = [];
				var url = "/orm/ormtb440/ormtb440Confirm";
				this.axios.post(url, postData).then(res => {
					console.log(res)
					setTimeout(() => {
						loading.close()
					}, 400)
					if (res.data.code == 200) {
						this.$message({
							message: '确认回执成功',
							type: 'success'
						});
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
				}).catch(() => {
					loading.close();
				})
			},
			// 客户--查询
			enterprise0ptions() {
				var postData = {
					ORMTB400ID: this.uobj.ormtb400.ORMTB400ID//一级企业id
				}
				var List = [{
					ORMTB410ID: '',
					ORMTB410CA00: '全部',
				}];
				var url = "/orm/ormtb410/selectOrmtb410s";
				this.axios.post(url, postData).then(res => {
					console.log(res)
					if (res.data.code == 200) {
						// 客户
						this.customerOptions = [...List,...res.data.data];
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
				})
			},
			materielMoPost(){
				var i = (this.enterpriseTwoOptionList|| []).findIndex((profile) => profile.SETTB99ID === this .enterpriseTwo);
				var url = "/set/settb109/selectPageList";
				var SETTB100ID=this.enterpriseTwoOptionList[i].SETTB100ID
				var data = {
					SETTB109CA03:'',
					SETTB109CA00:'',
					SETTB109CD01:SETTB100ID,
					SETTB99ID:this.enterpriseTwo,
					page: Number(1),
					limit: Number(10000),
				};
				var List = [{
					SETTB109CA00: '全部',
					SETTB109ID: '',
				}];
				this.axios.post(url, data).then(res => {
					console.log(res)
					if (res.data.code == 200) {
						this.materielOptions=[...List,...res.data.data];
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
				})
			},
			erpChange(){
				if(this.enterpriseTwo!=''){
					this.materielMoPost()
				}else{
					this.materielOptions=[{
					SETTB109CA00: '全部',
					SETTB109ID: '',
				}]
				}
			},
			// 获取下拉框信息--二级企业
			optionLists() {
				var postData = {
					SETTB100CA02: '', //用户类型
					ORMTB400ID: this.uobj.ormtb400.ORMTB400ID//一级企业id
				}
				var List = [{
					SETTB99ID: '',
					SETTB99CA00: '全部',
				}];
				var url = "/set/settb100/selectSettb100ByCa02";
				this.axios.post(url, postData).then(res => {
					console.log(res)
					if (res.data.code == 200) {
						var data = res.data.data
						// 二级企业
						this.enterpriseTwoOptionList =[...List,...data] ;
						if(this.enterpriseTwoOptionList.length==2){
							this.enterpriseTwo=this.enterpriseTwoOptionList[1].SETTB99ID
							this.materielMoPost()
						}
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					this.pageList()
				}).catch(() => {
					this.pageList()
					loading.close();
				})
			},
			// 查询
			queryClick() {
				this.pageList()
			},
			// 列表
			pageList() {
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					startTime: this.date[0], //开始时间
					endTime: this.date[1], //结束时间
					ORMTB440CA02: this.customerMo, //二级客户ID
					ORMTB400CA03: this.uobj.ormtb400.ORMTB400CA03, //一级客户代码
					ORMTB440CA04: this.enterpriseTwo,//二级企业ID
					ORMTB440CA06: this.materielMo, //物料ID
					ORMTB440CF01: this.SETTB122CA07, //状态
					ORMTB440CA00:this.ORMTB440CA00,//订单号
					ORMTB440CA01:this.carNumber,//车牌号
					page: this.pageMo,
					limit: this.limitMo
				}
				this.tableData = [];
				var url = "/orm/ormtb440/selectPageListLd";
				this.axios.post(url, postData).then(res => {
					console.log(res)
					setTimeout(() => {
						loading.close()
					}, 400)
					if (res.data.code == 200) {
						var data = res.data.data;
						this.pagingPageMo = res.data.count;
						for (var i = 0; i < data.length; i++) {
							var customerName = "";
							if (data[i]['ORMTB440CF01'] == '-1') {
								data[i]['ORMTB440CF01text'] = '取消'
							} else if (data[i]['ORMTB440CF01'] == '0') {
								data[i]['ORMTB440CF01text'] = '待接单'
							} else if (data[i]['ORMTB440CF01'] == '1') {
								data[i]['ORMTB440CF01text'] = '待提货'
							} else if (data[i]['ORMTB440CF01'] == '2') {
								data[i]['ORMTB440CF01text'] = '提货中'
							} else if (data[i]['ORMTB440CF01'] == '3') {
								data[i]['ORMTB440CF01text'] = '完成'
							} else if (data[i]['ORMTB440CF01'] == '4') {
								data[i]['ORMTB440CF01text'] = '回执'
							} else if (data[i]['ORMTB440CF01'] == '-2') {
								data[i]['ORMTB440CF01text'] = '申请取消'
							}
							if (data[i]['ORMTB440CC10'] == '0') {
								data[i]['auditText'] = '自动结算'
							} else if (data[i]['ORMTB440CC10'] == '1') {
								data[i]['auditText'] = '手动录入'
							} else if (data[i]['ORMTB440CC10'] == '2') {
								data[i]['auditText'] = '录入完毕'
							}
						}
						this.tableData = data;
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
				}).catch(() => {
					loading.close();
				})
			},
			// 详情
			DetailsClick(row) {
				this.oerderDetilsShow = true;
				this.querydetile(row)
			},
			isorderAuditClick(row) {
				this.isorderAuditShow = true;
				this.querydetile(row)
				this.isorderAuditmaterielMoPost(row)
			},
			orderAudit(row){
				this.orderAuditShow=true
				this.querydetile(row)
			},
			isorderAuditmaterielMoPost(row){
				var url = "/set/settb109/selectPageList";
				var data = {
					SETTB109CA03:'',
					SETTB109CA00:'',
					SETTB109CD01:row.ORMTB440CA23,
					SETTB99ID:row.ORMTB440CA04,
					page: Number(1),
					limit: Number(10000),
				};
				this.axios.post(url, data).then(res => {
					console.log(res)
					if (res.data.code == 200) {
						this.updateMaterialList=res.data.data;
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
				})
			},
			orderAuditServe(type){
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					ORMTB440CG00: type,
					ORMTB440CG02:this.uobj.pertb005.pertb005ca02,
					ORMTB440ID:this.detailsList.ORMTB440ID,
					ORMTB440CA02:this.detailsList.ORMTB440CA02,
					ORMTB440CA11:this.detailsList.ORMTB440CA11,
					ORMTB440CA12:this.detailsList.ORMTB440CA12,
				}
				this.tableData = [];
				var url = "/orm/ormtb440/updateORMTB440CG00";
				this.axios.post(url, postData).then(res => {
					console.log(res)
					setTimeout(() => {
						loading.close()
					}, 400)
					if (res.data.code == 200) {
						this.$message({
							message: '审核成功',
							type: 'success'
						});
						this.orderAuditShow=false
						this.pageList()
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
				}).catch(() => {
					loading.close();
				})
			},
			isorderAuditServe(){
				var i = (this.updateMaterialList|| []).findIndex((profile) => profile.SETTB109ID === this.detailsList.ORMTB440CC01);
				this.detailsList.ORMTB440CC02=this.updateMaterialList[i].SETTB109CA00
				if(this.detailsList.ORMTB440CC07=='') return this.$message.error('请输入结算流水号')
				if(this.detailsList.ORMTB440CC00==''&&this.detailsList.ORMTB440CE00=='') return this.$message.error('请选择结算时间或回执时间')
				if(this.detailsList.ORMTB440CC00!='') {
					if(this.detailsList.ORMTB440CC00<this.detailsList.ORMTB440CA19) return this.$message.error('请选择有效结算时间')
					if(this.detailsList.ORMTB440CC01=='') return this.$message.error('请选择结算物料')
					if(this.detailsList.ORMTB440CC04==='') return this.$message.error('请输入结算重量')
					if(this.detailsList.ORMTB440CC06==='') return this.$message.error('请输入结算金额')
				}
				if(this.detailsList.ORMTB440CE00!='') {
					if(this.detailsList.ORMTB440CE00<this.detailsList.ORMTB440CA19) return this.$message.error('请选择有效回执时间')
					if(this.detailsList.ORMTB440CE02==='') return this.$message.error('请输入回执重量')
					if(this.detailsList.ORMTB440CE04==='') return this.$message.error('请输入回执金额')
				}
				var formdata = new FormData()
				formdata.append('ORMTB440CC00', this.detailsList.ORMTB440CC00)
				formdata.append('ORMTB440CC01', this.detailsList.ORMTB440CC01)
				formdata.append('ORMTB440CC02', this.detailsList.ORMTB440CC02)
				formdata.append('ORMTB440CC04', this.detailsList.ORMTB440CC04)
				formdata.append('ORMTB440CC06', this.detailsList.ORMTB440CC06)
				formdata.append('ORMTB440CC07', this.detailsList.ORMTB440CC07)
				formdata.append('ORMTB440CE02', this.detailsList.ORMTB440CE02)
				formdata.append('ORMTB440CE04', this.detailsList.ORMTB440CE04)
				formdata.append('ORMTB440ID', this.detailsList.ORMTB440ID)
				this.imgFormdate.forEach(item => {
					formdata.append('file', item.raw)
				})
				var a = formdata.get('file')
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var url = "/orm/ormtb440/update";
				this.axios.post(url, formdata, {
					headers: {
						"Content-Type": "multipart/form-data"
					}
				}).then(res => {
					console.log(res)
					setTimeout(() => {
						loading.close()
					}, 400)
					if (res.data.code == 200) {
						this.$message({
							message: '录入成功',
							type: 'success'
						});
						this.isorderAuditShow=false
						this.pageList()
						this.fileList=[]
						this.imgFormdate=[]
						this.updateMaterialList=[]
						this.detailsList =''
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
				}).catch(() => {
					loading.close();
				})
			},
			querydetile(row){
				var postData = {
					ORMTB440ID: row.ORMTB440ID, //流水id
				}
				this.detailsList =''
				var url = "/orm/ormtb440/selectDetails";
				this.axios.post(url, postData).then(res => {
					console.log(res)
					if (res.data.code == 200) {
						this.detailsList = res.data.data;
						this.DetailsWatersrcList=[this.detailsList.ORMTB440CE01]
						this.DetailsWaterurl=this.detailsList.ORMTB440CE01
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					
				})
			},
			handleCheckAllChange(val) {
				this.checkedCities = val ? this.cities : [];
				this.isIndeterminate = false;
				this.tableHeadList = val ? this.tableHeadListInit : []
			},
			handleCheckedCitiesChange(value) {
				// console.log(value)
				let checkedCount = value.length;
				this.checkAll = checkedCount === this.cities.length;
				this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
				var changearr = this.checkedCities;
				var initarr = this.tableHeadListInit;
				this.tableHeadList = this.$baseAPI.columnSetup(changearr, initarr);
			},
			//获取当前时间
			getNowDay() {
				var date = new Date().getTime();
				var nowDay = this.$baseAPI.dateFtt("yyyy-MM-dd", new Date(date));
				this.date = [nowDay, nowDay];
				this.dateNowDayActive=true
				this.dateYesterdayActive=false
				this.dateNowMonthActive=false
				this.dateLastMonthActive=false
			},
			datePickerChange(e) {
				this.dateNowDayActive=false
				this.dateYesterdayActive=false
				this.dateNowMonthActive=false
				this.dateLastMonthActive=false
			},
			//获取昨天时间
			getYesterday() {
				var hms = new Date().getTime() - 86400000;
				var nowDay = this.$baseAPI.dateFtt("yyyy-MM-dd", new Date(hms));
				this.date = [nowDay, nowDay];
				this.dateNowDayActive=false
				this.dateYesterdayActive=true
				this.dateNowMonthActive=false
				this.dateLastMonthActive=false
			},
			//获取当月时间
			sameMonth() {
				var date = new Date();
				var hms = date.setDate(1);
				var firstDay = this.$baseAPI.dateFtt("yyyy-MM-dd", new Date(hms));
				var nextdate = new Date().getTime();
				var nextDay = this.$baseAPI.dateFtt("yyyy-MM-dd", new Date(nextdate));
				this.date = [firstDay, nextDay];
				this.startTime = this.date[0];
				this.endTime = this.date[1];
				this.dateNowDayActive=false
				this.dateYesterdayActive=false
				this.dateNowMonthActive=true
				this.dateLastMonthActive=false
			},
			//获取上月时间
			lastMonth() {
				var nowdays = new Date();
				var year = nowdays.getFullYear();
				var month = nowdays.getMonth();
				if (month == 0) {
					month = 12;
					year = year - 1;
				}
				if (month < 10) {
					month = "0" + month;
				}
				var firstDayOfPreMonth = year + "-" + month + "-" + "01";
				var lastDay = new Date(year, month, 0);
				let lastDayOfPreMonth = year + "-" + month + "-" + lastDay.getDate();
				this.date = [firstDayOfPreMonth, lastDayOfPreMonth];
				this.dateNowDayActive=false
				this.dateYesterdayActive=false
				this.dateNowMonthActive=false
				this.dateLastMonthActive=true
			},
			handleSizeChange(val) {
				this.pageMo =1
				this.limitMo = val;
				this.pageList();
			},
			// 点击页码
			handleCurrentChange(val) {
				this.pageMo = val;
				this.pageList();
			},
		}
	}
</script>

<style scoped>
	.CustomerfillingDig-tab {
		padding-left: 20px;
	}
	
	.CustomerfillingDig-tab-li,
	.rechargeType-tab-li {
		display: flex;
		height: 50px;
		line-height: 50px;
		text-align: center;
		font-size: 16px;
		color: #333;
		vertical-align: top;
	}
	
	.CustomerfillingDig-tab-li>div {
		border: 1px solid #CDCDCD;
		border-top: none;
	}
	
	.CustomerfillingDig-tab-li>div:first-child {
		border-right: none;
	}
	
	.CustomerfillingDig-tab-li:first-child>div {
		border-top: 1px solid #CDCDCD;
	}
	
	.CustomerfillingDig-tab-li>div:last-child,
	.rechargeType-tab-li>div:last-child {
		border: none;
		color: #FF4D35;
	}
	
	.CustomerfillingDig-tab-li-text {
		flex: .8;
		background: rgba(240, 252, 255, 1);
	}
	
	.CustomerfillingDig-tab-li-ipt {
		flex: .8;
	}
	
	.rechargeType-tab-li-text {
		flex: .35;
	}
	
	.rechargeType-tab-li-ipt {
		flex: .7;
	}
	
	.CustomerfillingDig-tab-li-ipt input,
	.rechargeType-tab-li-ipt input {
		height: 46px;
		width: 100%;
	
		text-align: center;
	
		box-sizing: border-box;
		font-size: 16px;
		color: #333;
	}
	
	.CustomerfillingDig-tab-li-ipt input {
		outline: none;
		border: none;
		vertical-align: top;
	}
	
	.rechargeType-tab-li-ipt input {
	}
	
	.CustomerfillingDig-tab-li-b,
	.rechargeType-tab-li-b {
		flex: .3;
	}
	
	.CustomerfillingDig-tab-btn {
		text-align: center;
		margin-top: 30px;
	}
	.DWD-li{
		display: flex;
		height: 45px;
		line-height: 45px;
		box-sizing: border-box;
		border: 1px solid #999;
		font-size: 16px;
		color: #333;
	}
	.DWD-li>div{
		padding: 0 5px;
		height: 44px;
		overflow: hidden;
		box-sizing: border-box;
	}
	.DWD-li-title{
		width: 120px;
		text-align: center;
		border-right: 1px solid #999;
		background-color: rgba(0, 163, 255,.1);
	}
	.DWD-li-text{
		flex: 1;
		box-sizing: border-box;
	}
	.DWD-li-text input{
		width: 100%;
		height: 42px;
		line-height: 42px;
		border: none;
		outline: none;
		box-sizing: border-box;
		padding: 0;
		vertical-align: top;
	}
	.DWD-li +.DWD-li{
		border-top: none;
	}
	.DWD-table{
		display: flex;
	}
	.DWD-table-left-flex{
		flex: 1;
	}
	.DWD-table>div>div{
		padding: 0 5px;
		height: 45px;
		line-height: 45px;
		overflow: hidden;
		text-align: center;
		border-right: 1px solid #999;
		border-bottom: 1px solid #999;
		box-sizing: border-box;
	}
	.DWD-table>div>div input{
		width: 100%;
		height: 45px;
		line-height: 45px;
		border: none;
		outline: none;
		box-sizing: border-box;
	}
	.DWD-table>div>div:first-child{
		background-color: rgba(0, 163, 255,.1);
	}
	
	.DWD-table-left-title>div{
		width: 101px;
		text-align: center;
		background-color: rgba(0, 163, 255,.1);
	}
	.DWD-table .DWD-table-left-title>div{
		padding: 0 5px;
		height: 45px;
		line-height: 45px;
		overflow: hidden;
		box-sizing: border-box;
		border-left: 1px solid #999;
		border-bottom: 1px solid #999;
	}
	.DetailsWater-img{
		margin-top: 30px;
	}
	.DetailsWater-img-text{
		display: inline-block;
		width: 101px;
		text-align: center;
		vertical-align: top;
	}
	.car-number-add {
		/* text-transform: uppercase; */
	}
	.billOperationRecord-table{
		padding: 30px 20px 0;
	}
	.public_singleMenu .pulic_carNumber {
		margin-top: 6px;
		height: 40px;
		line-height: 40px;
		box-sizing: border-box;
		font-size: 14px;
		display: inline-block;
	}

	.pulic_operatArea_now:hover,
	.public_operatArea_yesterday:hover {
		background-color: #ccc;
	}

	/* 新增--列表宽度 */
	.billOperationRecord .systemCodePC-add-code-table-li-ipt {
		flex: 1.5;
	}

	.fontBlue {
		color: rgba(25, 159, 255, 1) !important;
	}

	.public_oparetionBlock_Menu .pulic_carNumber {
		margin-top: 6px;
		height: 40px;
		line-height: 40px;
		box-sizing: border-box;
		font-size: 14px;
		display: inline-block;
	}

	.billOperationRecord .public_oparetionBlock_Menu {
		height: 45px;
		align-items: center;
	}

	.billOperationRecord {
		background-color: #f3f3f3;
	}

	.billOperationRecord th,
	.billOperationRecord td {
		text-align: center !important;
	}

</style>

